import React from 'react';
import Detection from './Detection';
import { useRoute, RouteProp } from '@react-navigation/native';
import { LPRParamList } from '../../../typings/Params';
import { RootNavigation } from '../../../Routes';

interface DetectionProps {
    navigation: RootNavigation;
}

export default function SearchLprDetection({ navigation }: DetectionProps) {
    const route = useRoute<RouteProp<LPRParamList, 'SearchLprDetection'>>();
    return <Detection navigation={navigation} route={route} page={'search'} />;
}
